import React from 'react'
import {
  DialogTitle,
  Box,
  Typography,
  IconButton,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface StatusDialogHeaderProps {
  activeTab: number
  onTabChange: (tab: number) => void
  onClose: () => void
  isLoading: boolean
}

export const StatusDialogHeader: React.FC<StatusDialogHeaderProps> = ({
  activeTab,
  onTabChange,
  onClose,
  isLoading,
}) => {
  return (
    <DialogTitle sx={{ flexShrink: 0, pt: 2.5, px: 3, pb: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" fontWeight="700" sx={{ letterSpacing: '-0.025em', color: 'text.primary' }}>
          Manage Status
        </Typography>
        <IconButton
          onClick={onClose}
          disabled={isLoading}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': { color: 'text.primary', bgcolor: 'action.hover' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <ToggleButtonGroup
        value={activeTab}
        exclusive
        onChange={(_, value) => {
          if (value !== null) {
            onTabChange(value)
          }
        }}
        fullWidth
        sx={{
          bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'),
          p: 0.5,
          borderRadius: '10px',
          border: 'none',
          mb: 1,
          '& .MuiToggleButtonGroup-grouped': {
            border: 'none',
            '&:not(:first-of-type)': { borderRadius: '8px' },
            '&:first-of-type': { borderRadius: '8px' },
          },
          '& .MuiToggleButton-root': {
            color: 'text.secondary',
            fontWeight: 500,
            transition: 'all 0.2s ease',
            '&.Mui-selected': {
              bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'background.paper' : '#fff'),
              color: 'primary.main',
              fontWeight: 600,
              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
              '&:hover': {
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'background.paper' : '#fff'),
                color: 'primary.main',
              },
            },
            '&:hover': {
              bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'),
            },
          },
        }}
      >
        <ToggleButton value={0} sx={{ textTransform: 'none', py: 0.75, fontSize: '0.875rem' }}>
          Create Status
        </ToggleButton>
        <ToggleButton value={1} sx={{ textTransform: 'none', py: 0.75, fontSize: '0.875rem' }}>
          Edit Status
        </ToggleButton>
      </ToggleButtonGroup>
    </DialogTitle>
  )
}
